<template>
  <div id="app">
      <span v-show="navShow">
        <div id="nav">
            <router-link :to="{ name:'home' }">List</router-link> |
            <router-link :to="{ name:'book' }" exact>Book</router-link>
        </div>
      </span>
      <transition mode="out-in">
          <router-view />
      </transition>
  </div>
</template>

<script>
  let debugOut = false
  import WebFontLoader from 'webfontloader'
  const forceNavHide = true
//const Velocity = require("velocity-animate");
export default {
  name:'App',
  components: {

  },
  created() {
    debugOut = this.$root.$options.debugOut
    this.$store.commit('setAppReferrer',document.referrer)
    this.$root.setNavHide = (nv) => {
      this.navShow = !nv && !forceNavHide
      if (debugOut) {console.log(`navShow : ${this.navShow}`)}
    }
    // this.$root.setNavHide(false)
    this.$store.commit('setFontActive', false)
    this.$root.ffamNombre = "Raleway Dots"
    if (debugOut) {console.log(this.$root)}
    if (debugOut) {console.log('font load')}
    WebFontLoader.load({
      google:{
        families: [this.$root.ffamNombre]       //'Noto Sans JP',
        // families: ['Noto Serif JP',this.$root.ffamNombre]       //'Noto Sans JP',
      },
      classes: false,
      custom:{
        families: ['Noto Serif JP','Noto-Serif-JPVO','Noto-Sans-JPVO']
        // families: ['Noto-Serif-JPVO','Noto-Sans-JPVO']
      },
      active: () => {
        this.$store.commit('setFontActive', true)
        if (debugOut) {console.log('web font activated!')}
            },
      inactive: () => {
        this.$store.commit('setFontActive', undefined)
      },
      fontactive: (ffam, fvd) => {
        if (debugOut) {console.log(`font active: ${ffam}`)}
      },
      fontinactive: (ffam, fvd) => {
        if (debugOut) {console.log(`font inactive: ${ffam}`)}
      },
      fontloading: (ffam, fvd) => {
        if (debugOut) {console.log(`font loading : ${ffam}`)}
      },
    })
    // this.verticalFontLoad()
  },
  data() {
    return {
      navShow : !forceNavHide,
    };
  },
  methods: {
    // verticalFontLoad() {
    //   WebFontLoader.load({
    //     custom:{
    //       families: ['Noto-Serif-JPV','Noto-Sans-JPV'],
    //       urls:['@/assets/sass/verticalfont.scss']
    //     },
    //     active: () => {
    //       this.$root.vFontActive = true
    //     },
    //     inactive: () => {
    //       this.$root.vFontActive = false
    //     },
    //   })
    // },
   },
  mounted() {
    this.updateDocumentAreaWH()
  },
  watch: {
  },
  computed: {
    // lNavHide() {
    //     if (debugOut) {console.log(`navHide:${this.$root.navHide}`)}
    //     return this.$root.navHide
    // },
  },
};
</script>

<style lang="scss">
.common {

}
* {
    user-select: none;
}
/*@import url("https://fonts.googleapis.com/css?family=Sawarabi+Mincho");*/
/*@import url("https://fonts.googleapis.com/css?family=Sawarabi+Gothic");*/
/*@import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP|Noto+Serif+JP&display=swap');*/
/*@import url("https://fonts.googleapis.com/css?family=M+PLUS+Rounded+1c");*/
/*@import url("https://fonts.googleapis.com/css?family=Orbitron");*/
/*.wf-mincho { font-family: "Sawarabi Mincho"; }*/
/*.wf-mincho { font-family: "Sawarabi Mincho"; }*/
/*.wf-gothic { font-family: "Sawarabi Gothic"; }*/
.wf-mincho { font-family: 'Noto Serif JP', serif; }
.wf-mincho-v { font-family: 'Noto-Serif-JPVO', 'Noto Serif JP', serif; }
/*.wf-gothic { font-family: 'Noto Sans JP', sans-serif; }*/
/*.wf-roundgothic { font-family: "M PLUS Rounded 1c"; }*/
/*.wf-orbitron { font-family: "Orbitron", sans-serif; };*/
/*.wf-cute { font-family: 'Cute Font', cursive; }*/
/*.wf-specialElete { font-family: 'Special Elite', cursive; }*/
@font-face {
    font-family: 'Noto Serif JP';
    font-style: normal;
    font-weight: 400;
    src: local('Noto Serif JP'), local('NotoSerifJP-Regular'),
    url('../public/fonts/NotoSerifJPORG.woff2') format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
    url('../public/fonts/NotoSerifJPORG.woff') format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
@font-face {
    font-family: 'Noto-Sans-JPVO';
    src:url('../public/fonts/NotoSansJPVO-Regular.woff2') format('woff2'),
        url('../public/fonts/NotoSansJPVO-Regular.woff') format('woff');
}
@font-face {
    font-family: 'Noto-Serif-JPVO';
    src:url('../public/fonts/NotoSerifJPVO-Regular.woff2') format('woff2'),
        url('../public/fonts/NotoSerifJPVO-Regular.woff') format('woff');
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
    z-index: -2000;
    position: absolute;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}
#nav {
  position: fixed;
  z-index: 11;
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  width: 95vw;
  font-size: x-small;
  text-align: right;
  vertical-align: top;

  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
    pointer-events: auto;
  }
}

html,body {
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

.unselectable {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.no-pointer {
  pointer-events: none;
}

.use-pointer {
  pointer-events: auto;
}
</style>
